// extracted by mini-css-extract-plugin
module.exports = {"ExitButton":"ExitButton_ExitButton__2HIJg","label":"ExitButton_label__1dOV3","icon":"ExitButton_icon__1OUog","cross":"ExitButton_cross__19amW"};